import React from 'react';
import { useFormRegistry } from '~/shared/forms/FormRegistryContext';
import { BlockNavigationPrompt } from '~/shared/forms/BlockNavigationPrompt';

export function VisitBucketItemBlocker() {
	const { hasAnyUnsavedChanges, blockerSuppressed } = useFormRegistry();
	return hasAnyUnsavedChanges && !blockerSuppressed ? <BlockNavigationPrompt /> : null;
}
